/* eslint-disable import/prefer-default-export */
import { dayMap } from './dayMap';
import { dayArray } from './dayArray';
import { dayMapMondayFirst } from './dayMapMondayFirst';
import { dayArrayMondayFirst } from './dayArrayMondayFirst';

export const getNumberOfCustomSessions = ({
  firstSession,
  endDate,
  availabilityPlan,
  firstDayOfWeek,
}) => {
  if (
    !firstSession ||
    !endDate ||
    !Array.isArray(availabilityPlan?.entries) ||
    availabilityPlan.entries.length === 0
  )
    return 0;

  const { timezone } = availabilityPlan;

  const currentMapForDay = firstDayOfWeek === 1 ? dayMapMondayFirst : dayMap; // 1 is monday
  const currentDayArray = firstDayOfWeek === 1 ? dayArrayMondayFirst : dayArray;

  const firstSessionDay = firstSession.tz(timezone).format('ddd').toLowerCase();
  const endDateDay = endDate.tz(timezone).format('ddd').toLowerCase();

  const firstSessionDayIndex = currentMapForDay[firstSessionDay];
  const endDateDayIndex = currentMapForDay[endDateDay];

  const eligibleDaysInFirstWeek = currentDayArray.slice(firstSessionDayIndex, 7);
  const eligibleDaysInEndWeek = currentDayArray.slice(0, endDateDayIndex + 1);
  const endWeekAndFirstWeekIsTheSame = endDate
    .clone()
    .startOf('week')
    .isSame(firstSession.clone().startOf('week'));

  const uniqueEligibleDays = [...new Set(availabilityPlan.entries.map((e) => e.dayOfWeek))];

  const sessionsInFirstWeek = eligibleDaysInFirstWeek.reduce((count, day) => {
    const entries = uniqueEligibleDays.filter((dayOfWeek) => dayOfWeek === day);
    return count + entries.length;
  }, 0);

  const sessionsInEndWeek = endWeekAndFirstWeekIsTheSame
    ? 0
    : eligibleDaysInEndWeek.reduce((count, day) => {
        const entries = uniqueEligibleDays.filter((dayOfWeek) => dayOfWeek === day);
        return count + entries.length;
      }, 0);

  const weeksBetweenStartAndEnd = endDate
    .clone()
    .tz(timezone)
    .startOf('week')
    .diff(firstSession.clone().tz(timezone).endOf('week'), 'weeks');

  const sessionsInAWeek = uniqueEligibleDays.length;

  const sessionsInFullWeeks =
    weeksBetweenStartAndEnd > 0 ? weeksBetweenStartAndEnd * sessionsInAWeek : 0;

  const totalSessions = sessionsInFirstWeek + sessionsInEndWeek + sessionsInFullWeeks;

  return totalSessions;
};
